import { API } from "../../utils/API";

const get = (params) => {
	return API.get("firma", { params }).then((res) => res.data);
};

export { get };
